module.exports = "/_next/static/images/bitcoin_cash-e3591e43008d6cb155bf5205621e184c.png";